module.exports = __webpack_public_path__ + "static/media/operationManagement_active.85033dd6.svg";